import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/login/Login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/home/Home.vue')
  }, {
    path: '/detail',
    name: 'Detail',
    component: () => import('../views/detail/Detail.vue')
  }, {
    path: '/report',
    name: 'Report',
    component: () => import('../views/report/Report.vue')
  } ,{
    path: '/regist',
    name: 'Regist',
    component: () => import('../views/regist/Regist.vue')
  }

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  base:'/anno_java',
  routes
})

export default router
